import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@barthauer/abc/queries/opath/core';
import {
  AbcAccordionComponent,
  AbcDateBoxComponent,
  AbcDropDownBoxComponent,
  AbcListComponent,
  AbcNumberBoxComponent,
  AbcTextBoxComponent,
  _AbcButtonComponent,
  _AbcCheckBoxComponent,
  _AbcFormComponent,
  _AbcScrollViewComponent,
  _AbcSelectBoxComponent,
  _AbcTextAreaComponent,
} from '@barthauer/abc/ui-components';
import { DxTemplateModule, DxValidatorModule } from 'devextreme-angular';
import { DefinitionsEditorContainerComponent } from './definitions-editor-container/definitions-editor-container.component';
import { DefinitionsEditorComponent } from './definitions-editor.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    AbcListComponent,
    _AbcButtonComponent,
    _AbcScrollViewComponent,
    AbcAccordionComponent,
    AbcDropDownBoxComponent,
    AbcDateBoxComponent,
    _AbcTextAreaComponent,
    _AbcCheckBoxComponent,
    AbcNumberBoxComponent,
    AbcTextBoxComponent,
    DxValidatorModule,
    DxTemplateModule,
    _AbcFormComponent,
    _AbcSelectBoxComponent,
  ],
  declarations: [DefinitionsEditorComponent, DefinitionsEditorContainerComponent],
  exports: [DefinitionsEditorComponent, DefinitionsEditorContainerComponent],
})
export class DefinitionsEditorModule {}
